import { React, useEffect, useState } from "react";
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Pagination,
  Paper,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Avatar,
  Grid,
  IconButton,
  Stack,
  Modal,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Active, Inactive } from "../Svg";

import DelModal from "../pages/MinistryAdminPortal/Provinces/DelModal";
import { headersPost } from "../Services/API";
import { MINISTRY_API_ULRS } from "../Services/Routes/API";
import { RoutesUrls } from "../Services/Routes/APP";

const usersHeading = ["Name", "Email", " Status", "Action"];

const UsersModal = ({ users, onClose, open }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [product2, setProduct2] = useState(null);
  const [usersModal, setUsersModal] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertIcon, setAlertIcon] = useState("error");
  const [alertMsg, setAlertMsg] = useState("");
  const [open2, setOpen2] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [api, setApi] = useState(false);

  // nothing

  // const apiState = useState(false);
  // alert(typeof apiState);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const delProduct2 = (pro, users_modal) => {
    setProduct2(pro);
    setUsersModal(users_modal);

    setOpenModal(true);
  };
  const closeModalHandler = () => {
    setOpenModal(false);
  };
  const provinceDelHandler2 = () => {
    const data2 = {
      user: {
        id: product2?.id,
        is_active: product2?.is_active ? false : true,
      },
    };

    setOpen2(true);

    headersPost(MINISTRY_API_ULRS?.UPDATE_USERS, data2)
      .then((res) => {
        setOpen2(false);
        if (res?.status === 200 && res?.data?.success) {
          const { data } = res;
          const { user } = data;
          const { id: userId } = user;
          setUsersList((prev) =>
            prev?.map((users2) => {
              const { id } = users2;
              if (id === userId) {
                return user;
              }
              setUsersList(users2);

              return users2;
            })
          );
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen2(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
    setOpenModal(false);
  };
  useEffect(() => {
    setUsersList(users);
  }, [users]);

  return (
    <Box>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            minWidth: "50%",
            maxWidth: "90%",
            maxHeight: "80%",
            minHeight: "70%",
            boxShadow: 24,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {usersHeading?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      <Chip
                        label={h}
                        sx={{
                          backgroundColor: theme.palette.secondary.dark,
                          borderRadius: 2,
                          color: theme.palette.primary.main,
                        }}
                      ></Chip>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {usersList?.map((row, index) => (
                  <TableRow key={`${index}-row.name-${index + 2}`}>
                    <TableCell align="center">{row?.name}</TableCell>
                    <TableCell align="center">{row?.email}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={row?.is_active ? "Not verified" : "Verified"}
                        sx={{
                          backgroundColor: row?.is_active
                            ? `${theme.palette.error.light}`
                            : `${theme.palette.success.light}`,

                          borderRadius: 2,
                          color: row?.is_active
                            ? `${theme.palette.error.main}`
                            : `${theme.palette.success.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Button
                          variant="contained"
                          onClick={() => delProduct2(row, "users_modal")}
                          size="small"
                          sx={{
                            padding: 0,
                            borderRadius: 4,
                          }}
                        >
                          {row?.is_active ? <Inactive /> : <Active />}
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
      <DelModal
        // status={product?.is_active}
        status2={product2?.is_active}
        open={openModal}
        handleClose={closeModalHandler}
        // provinceDelHandler={provinceDelHandler}
        // provinceDelHandler2={provinceDelHandler2}
        usersModal={usersModal}
        NodeViewDelHandler={provinceDelHandler2}
      />
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open2}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UsersModal;
